import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=6401eae5&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401eae5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6401eae5')) {
      api.createRecord('6401eae5', component.options)
    } else {
      api.reload('6401eae5', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=6401eae5&scoped=true", function () {
      api.rerender('6401eae5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/area/areamenu/edit.vue"
export default component.exports